import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { LocalizedRouteService, ProfileState } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../localized-user-routes-const';

/**
 * Sends a newsletter-only user — a subscriber without any other right — to their newsletter archive
 * instead of a dashboard that would show them nothing. Everybody else passes.
 *
 * @returns {boolean | UrlTree} True, or the archive's address.
 */
export const newsletterOnlyRedirectGuard: CanActivateFn = (): boolean | UrlTree => {
  if (!inject(Store).selectSnapshot(ProfileState.isNewsletterOnly)) {
    return true;
  }

  const archive = inject(LocalizedRouteService).getLocalizedRoute(
    LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_DOWNLOADS],
    LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_DOWNLOADS_NEWSLETTER],
  );
  return inject(Router).parseUrl(`/${archive}`);
};
